import React from 'react';
import PostStatusBadge from './forms/PostStatusBadge';
import PostStatusDropdown from './forms/PostStatusDropdown';

const WEEKDAYS = {
  'Segunda': 'SEG', 'Terca': 'TER', 'Quarta': 'QUA',
  'Quinta': 'QUI', 'Sexta': 'SEX', 'Sabado': 'SAB', 'Domingo': 'DOM',
};

function CalendarWidget({ posts, showClient = false, compact = false, onChangeStatus, onPostClick }) {
  if (!posts || posts.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">&#x1F4C5;</div>
        <p>Nenhum post agendado</p>
      </div>
    );
  }

  return (
    <div>
      {posts.map(post => (
        <div
          key={post.id}
          className="calendar-post"
          style={onPostClick ? { cursor: 'pointer' } : undefined}
          onClick={() => onPostClick && onPostClick(post)}
        >
          <div className="calendar-date">
            <div className="calendar-date-day">{post.day}</div>
            <div className="calendar-date-weekday">{WEEKDAYS[post.weekday] || post.weekday}</div>
          </div>
          <div className="calendar-post-info">
            <div className="calendar-post-title">
              {post.workingTitle || post.title}
            </div>
            <div className="calendar-post-meta">
              {showClient && <span>{post.clientName}</span>}
              <span>{post.format}</span>
              {post.withFace && <span>Com rosto</span>}
              {!compact && post.funnelStage && (
                <span className="badge badge--accent">{post.funnelStage}</span>
              )}
              {!compact && post.pillar && (
                <span className="badge badge--success">{post.pillar}</span>
              )}
            </div>
          </div>
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
            {onChangeStatus ? (
              <PostStatusDropdown
                status={post.status || 'draft'}
                onChangeStatus={(newStatus) => onChangeStatus(post.id, newStatus)}
              />
            ) : (
              post.status && <PostStatusBadge status={post.status} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default CalendarWidget;
